import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common'; // <-- add this import
import { TranslateService } from '@ngx-translate/core';
import { LocalizationService } from './services/localization/localization.service';
import { ViewportScroller } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import * as AOS from 'aos';
import { environment } from 'src/environments/environment';
import { LoadingService } from './services/loading/loading.service';

declare let fbq: (...args: any[]) => void;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'up-career';
  isBrowser: boolean;
  loading = false;

  constructor(
    private translateService: TranslateService,
    private localizationService: LocalizationService,
    private router: Router,
    private viewportScroller: ViewportScroller,
    private loaderService: LoadingService,
    @Inject(PLATFORM_ID) private platformId: Object // <-- Inject platform ID
  ) {
    const lang = this.localizationService.getUserLang();
    this.translateService.use(lang);

    this.isBrowser = isPlatformBrowser(this.platformId); // <-- Check if browser
    console.log('Environment:', environment.envName);

    this.loaderService.loading$.subscribe((status: boolean) => {
      this.loading = status;
    });
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.loadFacebookPixel();
      AOS.init({ once: true });
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd && this.isBrowser) {
        const path = event?.urlAfterRedirects;
        AOS.refresh();

        if (typeof fbq !== 'undefined') {
          fbq('track', 'PageView');
          fbq('trackCustom', 'RouteView', { path });
        }
      }
    });
  }

  loadFacebookPixel() {
    if (this.isBrowser && typeof document !== 'undefined') {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1328108511805666');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
    }
  }
  
}
